import { useState } from 'react';
import { MessageBar, MessageBarBody, Tab, TabList, tokens } from '@fluentui/react-components';
import { PageHeader } from '../components/PageHeader';
import { useSession } from '../auth/SessionProvider';
import { CorporateDesignSettings } from '../components/CorporateDesignSettings';
import { AccessSettings } from '../components/AccessSettings';
import { RoleAccessSettings } from '../components/RoleAccessSettings';
import { LicenseSettings } from '../components/LicenseSettings';
import { SbomSettings } from '../components/SbomSettings';

type SettingsTab = 'design' | 'roles' | 'access' | 'licenses' | 'sbom';

export function SettingsPage() {
  const { me } = useSession();
  const [tab, setTab] = useState<SettingsTab>('design');

  if (me && !me.isAdmin) {
    return (
      <div>
        <PageHeader title="Einstellungen" />
        <MessageBar intent="warning">
          <MessageBarBody>
            Zentrale Einstellungen sind Mitgliedern der M365-Admin-Gruppe vorbehalten.
          </MessageBarBody>
        </MessageBar>
      </div>
    );
  }

  return (
    <div>
      <PageHeader title="Einstellungen" description="Zentrale Konfiguration für alle Nutzer." />
      <TabList
        selectedValue={tab}
        onTabSelect={(_, d) => setTab(d.value as SettingsTab)}
        style={{ marginBottom: tokens.spacingVerticalL }}
      >
        <Tab value="design">Corporate Design</Tab>
        <Tab value="roles">Rollen</Tab>
        <Tab value="access">Zugriffe</Tab>
        <Tab value="licenses">Lizenzen</Tab>
        <Tab value="sbom">SBOM</Tab>
      </TabList>

      {tab === 'design' ? (
        <CorporateDesignSettings />
      ) : tab === 'roles' ? (
        <RoleAccessSettings />
      ) : tab === 'access' ? (
        <AccessSettings />
      ) : tab === 'licenses' ? (
        <LicenseSettings />
      ) : (
        <SbomSettings />
      )}
    </div>
  );
}
